import { UserInfo } from "../../@types/auth.types";

export const setUser = (user: UserInfo) => ({
  type: "SET_USER",
  payload: user,
});
